// Loader dismiss
window.addEventListener('load',()=>{setTimeout(()=>{document.getElementById('loader').classList.add('done')},1500)});

// Nav scroll effect + floating shop
const nav=document.getElementById('nav');
const fab=document.getElementById('floatingShop');
let lastScroll=0;
window.addEventListener('scroll',()=>{
  const y=window.scrollY;
  nav.classList.toggle('scrolled',y>60);
  fab.classList.toggle('visible',y>window.innerHeight*.5);
  lastScroll=y;
},{passive:true});

// Reveal on scroll (IntersectionObserver)
const obs=new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target)}
  })
},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.rv').forEach(el=>obs.observe(el));

// Trigger hero reveals after loader
setTimeout(()=>{document.querySelectorAll('.hero .rv').forEach(el=>el.classList.add('vis'))},1700);

// Language selector
const langBtns=document.querySelectorAll('[data-lang]');
langBtns.forEach(btn=>{
  btn.addEventListener('click',()=>{
    window.open('https://homeland-ai.com/?locale='+btn.dataset.lang,'_blank');
  });
});
